// src/component.ts
function mode(light, dark) {
  return function (props) {
    return props.colorMode === "dark" ? dark : light;
  };
}

function orient(options) {
  var orientation = options.orientation,
      vertical = options.vertical,
      horizontal = options.horizontal;
  if (!orientation) return {};
  return orientation === "vertical" ? vertical : horizontal;
}

export { mode, orient };